import { render, staticRenderFns } from "./UpdateBrowserPermissions.vue?vue&type=template&id=fe410e9a&lang=pug&"
import script from "./UpdateBrowserPermissions.vue?vue&type=script&lang=js&"
export * from "./UpdateBrowserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports